export type EmailConfirmationTokenPayload = {
  email: string;
  id: string;
};

export function encodeEmailConfirmationToken(
  payload: EmailConfirmationTokenPayload
): string {
  const json = JSON.stringify(payload);
  return encodeURIComponent(btoa(json));
}

export function decodeEmailConfirmationToken(
  token: string
): EmailConfirmationTokenPayload | null {
  try {
    const decodedJson = atob(decodeURIComponent(token));
    const parsed = JSON.parse(
      decodedJson
    ) as Partial<EmailConfirmationTokenPayload>;

    if (
      !parsed ||
      typeof parsed.email !== "string" ||
      typeof parsed.id !== "string"
    ) {
      return null;
    }

    return {
      email: parsed.email,
      id: parsed.id,
    };
  } catch {
    return null;
  }
}
